<template>
  <el-container class="setup">
    <el-header style="height:40px;padding: 15px 30px">
      <header-crunb :crumbList="crumbList"></header-crunb>
    </el-header>
    <el-container class="container">
      <el-aside width="200px">
        <el-menu
          class="el-menu-vertical-demo"
          text-color="#000"
          active-text-color="#000"
          unique-opened
          router
          :default-active="defaultActive"
        >
          <template v-for="menu in menuList">
            <template v-if="menu.menuInfoList&&menu.menuInfoList.length>0">
              <el-submenu
                :index="menu.menuCode"
                :key="menu.menuCode"
              >
                <!-- 设置标题 具名插槽 -->
                <template v-slot:title>
                  <i :class="'iconfont '+ menu.menuIcon">
                  </i>
                  <span>{{ menu.menuName}}</span>
                </template>
                <!-- 设置内容 -->
                <el-menu-item
                  :index="item.menuCode"
                  v-for="item in menu.menuInfoList"
                  :key="item.menuCode"
                >
                  <span slot="title">{{ item.menuName }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item
                :index="menu.menuCode"
                class="not-children"
                :key="menu.menuCode"
              >
                <span slot="title">{{ menu.menuName }}</span>
              </el-menu-item>
            </template>
          </template>

        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import HeaderCrunb from "@/components/HeaderCrunb.vue";
export default {
  components: {
    HeaderCrunb,
  },
  computed: {
    ...mapState(["userInfo", "activeLabelInfo"]),
    schoolInfo() {
      return this.userInfo.teacherInfoList.find(
        (i) => i.classCode == this.$route.query.classCode
      );
    },
    defaultActive() {
      return this.$route.path.slice(7);
    },
    crumbList() {
      return [
        {
          path: "/indexLabel",
          name: "标签 (" + this.activeLabelInfo.menuName + ")",
          id: 1,
        },
        {
          path: "",
          name: "编辑表扬与提醒",
          id: 2,
        },
      ];
      return this.$route.meta.crumbList;
    },
  },
  data() {
    return {
      menuList: [
        {
          menuCode: "praise",
          menuName: "编辑表扬与提醒",
        },
        // {
        //   menuCode: "label",
        //   menuName: "编辑评价标签",
        // },
      ],
    };
  },
  created() {
    //this.init();
  },
  methods: {
    init() {
      this.menuList = this.userInfo.menuInfoList;
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.setup {
  .container {
    .el-aside {
      padding-top: 6px;
      overflow-x: hidden;
      height: calc(100vh - 100px);
      .el-menu {
        border-right: none;
        /deep/.el-submenu__title {
          font-size: 14px;
        }
        .el-menu-item {
          font-size: 14px;
          i {
            font-size: 17px;
            font-weight: 700;
            margin-right: 10px;
          }
        }
      }
      /deep/.el-menu-item,
      .el-submenu__title {
        height: 53px;
        line-height: 53px;
        i {
          font-size: 17px;
          font-weight: 700;
          margin-right: 10px;
        }
      }
      .el-menu-item.is-active {
        width: 100%;
        //background-color: @color !important;
        border-radius: 10px;
        color: @color !important;
      }
      .el-submenu {
        .el-menu-item {
          padding-left: 55px !important;
          font-size: 14.4px;
        }
      }
    }
    .el-main {
      background-color: #ecf0f1;
      padding: 12px;
    }
  }
}
</style>
